import { render, staticRenderFns } from "./operationInstructionColor.vue?vue&type=template&id=1ec91c2d&scoped=true"
import script from "./operationInstructionColor.vue?vue&type=script&lang=js"
export * from "./operationInstructionColor.vue?vue&type=script&lang=js"
import style0 from "./operationInstructionColor.vue?vue&type=style&index=0&id=1ec91c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec91c2d",
  null
  
)

export default component.exports